export default __webpack_public_path__ + "assets/img/Delete_Sucs.9b4720fb.svg";